import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    SIGNOUT_SUCCESS,
    MODAL_SHOW,
    MODAL_TYPE_SUCCESS,
    SIGNUP_SUCCESS,
    SIGNUP_ERROR,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_ERROR,
    LOADING_SCREEN_SHOW,
    LOADING_SCREEN_HIDE,
    MODAL_HIDE,
    MODAL_TYPE_CONFIRM_SIGN_OUT,
    MODAL_TYPE_OK,
    SET_CUSTOMER_DATA,
    MODAL_TYPE_VERIFY_OTP,
    OTP_RESPONSE_WAITING,
    MODAL_TYPE_ERROR,
    SET_I18N_DATA,
    MODAL_TYPE_LOGIN_ERROR,
    POLICY_LOAD_VIEW_SCREEN_HIDE,
    RESET_QUOTE_DATA,
    RESET_CART_DATA,
    SET_LINK_METHOD,
    MODAL_TYPE_VERIFY_OTP_LIFE,
    SET_LIFE_POLICY,
    SET_LIFE_CONTACT,
    POLICY_LOAD_VIEW_SCREEN_SHOW,
    SET_CLAIM_DATA,
    SET_EXTERNAL_DATA,
    SET_INSPECTION_ITEMS,
    SET_QUOTED_FUTURE_ITEMS,
    EMPTY_GUID, PRODUCT_PORTABLE_POSSESSIONS, SET_IS_LIVIN_ENABLED, POLICY_COVER_ITEM,
} from '../constants/constants';
import {
    ERROR_HEADER, EMAIL_IN_USE, INVALID_USERNAME_OR_PASSWORD, YOU_HAVE_MAIL,
    PASSWORD_RESET_EMAIL_SENT, PASSWORD_RESET_EMAIL_NOT_SENT, LINKED_POLICY_SUCCESS,
    LOG_OUT_ARE_YOU_SURE, ERROR_SOMETHING_WENT_WRONG, ERROR_OTP_REQUEST_FAILED, ERROR_INVALID_OTP
} from '../constants/copy'
import {
    postToController,
    logErrorToDatabase,
    logWarningToDatabase,
    logInfoToDatabase,
    getFromController
} from './apiActions';
import {
    BUILDING_AND_CONTENT_JOURNEY_BUILDER, CLAIM_HISTORY_V2, CODE_RED_VIEW_BUILDER,
    DASHBOARD,
    FNOL_SUBMIT_CLAIM, HOME,
    LOGIN, PERSONAL_INFO,
    PERSONAL_INSURANCE, POLICY_DETAILS, PORTABLE_POSSESSIONS, WARRANTY_JOURNEY_BUILDER
} from '../routes/routes';
import {checkSpecialDebitDate, getUserBankingDetails, setSelectedCover, setSelectedQuotedCover} from './profileActions';
import {navigateTo} from './navigationActions';
import {
    NAM_ADDRESS1,
    NAM_ADDRESS2,
    NAM_ADDRESS3,
    NAM_ADDRESS4,
    NAM_CLAIMS_EMAIL,
    NAM_CLIENT_CARE_EMAIL,
    NAM_KP_FSP,
    NAM_LAT,
    NAM_LONG,
    NAM_SALES_EMAIL,
    NAM_TEL,
    SA_LAT,
    SA_LONG,
    SA_ADDRESS1,
    SA_ADDRESS2,
    SA_ADDRESS3,
    SA_ADDRESS4,
    SA_TEL,
    SA_CLIENT_CARE_EMAIL,
    SA_CLAIMS_EMAIL,
    SA_SALES_EMAIL,
    SA_KP_FSP, SA_COUNTRY_ID_NUMBER, NAM_COUNTRY_ID_NUMBER
} from '../constants/internationalization';
import {isEmpty, isLoaded} from 'react-redux-firebase';
import {hideLoadingScreen, showLoadingScreen} from './fullscreenActions';
import {setIsLivinEnabled, setFeaturesEnabled} from './sspActions';
import {logEvent} from '../firebase/firebase';
import {isMobile} from 'react-device-detect';
import {
    checkContinueAndSetData,
    clearSelectedDamages,
    resetFNOL,
    setCoverFromPersonalInsurance, setStepClaim
} from './claimSubmitActions';
import {getClaimProgress, getNextProgressStepName, setLoadingAndEmpty} from './claimHistoryActionsV2';
import {showModalInvalidEmail, showModalNoEmail} from './policyModalActions';
import {validateEmail} from '../constants/validation';
import {showAddNewItem} from './modalActions';
import 'firebase/database';
import {syncCoverWithProfile} from './selfInspectActions';
import {
    createQuoteFromPolicy,
    initiateBuildingSteps, initiateCodeRedSteps, initiateHomeContentSteps, initiateWarrantySteps,
    loadAllAddresses, newMobileClientCheck, setQuoteType, setStep
} from "./salesActions";
import {refreshCart} from "./cartActions";
import {store} from "../store/configureStore";

export const signInWithCredentials = (credentials: any) => {
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        try {
            await dispatch(showLoadingScreen());
            let navigate = getState().external.riskItemId === null;
            await dispatch({type: LOADING_SCREEN_SHOW});
            const firebase = getFirebase();
            await firebase.auth().signInWithEmailAndPassword(
                credentials.email,
                credentials.password
            ).catch(async (err) => {
                logWarningToDatabase("Login error (credentials): '" + credentials.email + "' Error: " + err);
                firebaseError = true;
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: INVALID_USERNAME_OR_PASSWORD,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
            }).then(async () => {
                if (!firebaseError) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA,
                        payload: {email: credentials.email, loginEmail: credentials.email}
                    });
                    if (await postSignInSignUp(dispatch, getState, credentials.email)) {
                        await dispatch({type: LOGIN_SUCCESS, payload: "kingprice"});
                    } else {
                        await dispatch({type: LOGIN_ERROR});
                    }
                }
            }).catch(async (err) => {
                logErrorToDatabase("Error post login (credentials): '" + credentials.email + "' Error: " + err);
                await dispatch({type: LOGIN_ERROR});
            }).finally(async () => {
                await dispatch(loginComplete(firebaseError, navigate));
            });
        } catch (err) {
            logErrorToDatabase("Error signInWithCredentials: '" + credentials.email + "' Error: " + err);
            await dispatch({type: LOGIN_ERROR});
            await dispatch(loginComplete(firebaseError));
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
        await dispatch({type: LOADING_SCREEN_HIDE});
    }
}

export const signInAnon = (navigateToDashboard: boolean = true, showProductsModal: boolean = true) => {
    //Note firebase needs to be 3rd parameter here.
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        await dispatch({type: LOADING_SCREEN_SHOW});
        try {
            await dispatch(signOut(false));
            await setFeaturesEnabled();
            const firebase = getFirebase();
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            await firebase.auth().signInAnonymously(
            ).then(async () => {
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: true,
                    }
                });
                await dispatch({type: LOGIN_SUCCESS, payload: "anon"});
                if (showProductsModal) {
                    await dispatch(showAddNewItem());
                }
            }).catch(async () => {
                firebaseError = true;
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: INVALID_USERNAME_OR_PASSWORD,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
            }).finally(async () => {
                await dispatch(loginComplete(firebaseError, navigateToDashboard));
            });
        } catch (err) {
            logErrorToDatabase("Error post signInAnon. Error: " + err);
            await dispatch({type: LOGIN_ERROR});
            await dispatch(loginComplete(firebaseError));
        }
        await dispatch({type: LOADING_SCREEN_HIDE});
    }
}

export const signInAnonRedirect = () => {
    //Note firebase needs to be 3rd parameter here.
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        await dispatch({type: LOADING_SCREEN_SHOW});
        try {
            const firebase = getFirebase();
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            await firebase.auth().signInAnonymously(
            ).then(async () => {
                await dispatch({type: LOGIN_SUCCESS, payload: "anonredirect"});
            }).catch(async () => {
                firebaseError = true;
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: INVALID_USERNAME_OR_PASSWORD,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
                await dispatch(navigateTo(DASHBOARD))
            }).finally(() => {
            });
        } catch (err) {
            logErrorToDatabase("Error post signInAnon. Error: " + err);
            await dispatch({type: LOGIN_ERROR});
        }
        await dispatch({type: LOADING_SCREEN_HIDE});
    }
}


export const signInWithGoogle = () => {
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        try {
            dispatch({type: LOADING_SCREEN_SHOW});
            let navigate = getState().external.riskItemId === null;
            const firebase = getFirebase();
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider()
            ).catch(async (err) => {
                logWarningToDatabase("Login error (google), Error: " + err);
                firebaseError = true;
                await dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: err.message,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
            }).then(async (resp) => {
                if (!firebaseError) {
                    if (resp.user.email !== '') {
                        await dispatch({
                            type: SET_CUSTOMER_DATA,
                            payload: {email: resp.user.email, loginEmail: resp.user.email}
                        });
                    }
                    if (await postSignInSignUp(dispatch, getState, resp.user.email)) {
                        await dispatch({type: LOGIN_SUCCESS, payload: "google"});
                    } else {
                        await dispatch({type: LOGIN_ERROR});
                    }
                }
            }).catch(async (err) => {
                logErrorToDatabase("Error post login (google), Error: " + err);
                await dispatch({type: LOGIN_ERROR});
                await dispatch({type: LOADING_SCREEN_HIDE});
            }).finally(async () => {
                await dispatch(loginComplete(firebaseError, navigate));
            });
        } catch (err) {
            logErrorToDatabase("Error signInWithGoogle, Error: " + err);
            await dispatch({type: LOADING_SCREEN_HIDE});
            await dispatch({type: LOGIN_ERROR});
            await dispatch(loginComplete(firebaseError));
        }
    }
}

export const signInWithFacebook = () => {
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        try {
            dispatch({type: LOADING_SCREEN_SHOW});
            let navigate = getState().external.riskItemId === null;
            const firebase = getFirebase();
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider()
            ).catch(async (err) => {
                logWarningToDatabase("Login error (facebook), Error: " + err);
                firebaseError = true;
                await dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: err.message,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
            }).then(async (resp) => {
                if (!firebaseError) {
                    if (resp.user.email !== '') {
                        await dispatch({
                            type: SET_CUSTOMER_DATA,
                            payload: {email: resp.user.email, loginEmail: resp.user.email}
                        });
                    }
                    if (await postSignInSignUp(dispatch, getState, resp.user.email)) {
                        await dispatch({type: LOGIN_SUCCESS, payload: "facebook"});
                    } else {
                        await dispatch({type: LOGIN_ERROR});
                    }
                }
            }).catch(async (err) => {
                logErrorToDatabase("Error post login (facebook), Error: " + err);
                dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({type: LOGIN_ERROR});
            }).finally(async () => {
                await dispatch(loginComplete(firebaseError, navigate));
            });
        } catch (err) {
            logErrorToDatabase("Error signInWithFacebook, Error: " + err);
            await dispatch({type: LOGIN_ERROR});
            await dispatch(loginComplete(firebaseError));
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

export const signInWithApple = () => {
    return async (dispatch, getState, {getFirebase}) => {
        var firebaseError = false;
        try {
            await dispatch({type: LOADING_SCREEN_SHOW});
            let navigate = getState().external.riskItemId === null;
            const firebase = getFirebase();
            var provider = new firebase.auth.OAuthProvider('apple.com');
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            firebase.auth().signInWithPopup(provider
            ).catch(async (err) => {
                logWarningToDatabase("Login error (apple), Error: " + err);
                firebaseError = true;
                await dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: err.message,
                    }
                });
                await dispatch({type: LOGIN_ERROR});
            }).then(async (resp) => {
                if (!firebaseError) {
                    if (resp.user.email !== '') {
                        dispatch({
                            type: SET_CUSTOMER_DATA,
                            payload: {email: resp.user.email, loginEmail: resp.user.email}
                        });
                    }
                    if (await postSignInSignUp(dispatch, getState, resp.user.email)) {
                        await dispatch({type: LOGIN_SUCCESS, payload: "apple"});
                    } else {
                        await dispatch({type: LOGIN_ERROR});
                    }
                }
            }).catch(async (err) => {
                logErrorToDatabase("Error post login (apple), Error: " + err);
                await dispatch({type: LOGIN_ERROR});
                await dispatch({type: LOADING_SCREEN_HIDE});
            }).finally(async () => {
                await dispatch(loginComplete(firebaseError, navigate));
            });
        } catch (err) {
            logErrorToDatabase("Error signInWithApple, Error: " + err);
            await dispatch({type: LOGIN_ERROR});
            await dispatch(loginComplete(firebaseError));
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

export const loginComplete = (firebaseError: boolean, navigateToDashboard: boolean = true) => {
    return async (dispatch, getState) => {
        if (!firebaseError) {
            var errorOccured = getState().auth.authError !== null;
            if (errorOccured) {
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_LOGIN_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            } else {
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: navigateToDashboard,
                    }
                });
                if (navigateToDashboard) {
                    await dispatch(navigateTo(DASHBOARD));
                }
            }
            await dispatch({type: LOADING_SCREEN_HIDE});
            logEvent('SSP_login', {error: errorOccured});
        }
    };
}

export const confirmSignOut = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CONFIRM_SIGN_OUT,
                isHtml: true,
                header: '',
                body: "<div class='text-center'><h3 class=' mb-1 Log-out'>Log out</h3><p>" + LOG_OUT_ARE_YOU_SURE + "</p></div>",
            }
        })
    };
}

export const hideSignOutModal = () => {
    return (dispatch) => {
        dispatch({type: MODAL_HIDE});
    }
}

export const signOut = (navigateToLogin: boolean = true) => {
    return (dispatch, getState, {getFirebase}) => {
        try {
            dispatch({type: MODAL_HIDE});
            dispatch({type: LOADING_SCREEN_SHOW});
            const firebase = getFirebase();
            firebase.auth().signOut()
                .then(async () => {
                    dispatch({type: LOADING_SCREEN_HIDE});
                    dispatch({type: SIGNOUT_SUCCESS});
                    getFromController(dispatch, 'CountryId', null).then((response) => {
                        dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                countryId: response,
                                currencySymbol: (response === 157) ? 'N$' : 'R'
                            }
                        })
                    });
                    if (navigateToLogin) {
                        dispatch(navigateTo(HOME));
                    }
                });
        } catch (err) {
            logErrorToDatabase("Error signOut, Error: " + err);
            dispatch({type: LOADING_SCREEN_HIDE});
            dispatch(navigateTo(HOME));
        }
    }
}

export const passwordReset = (userEmail) => {
    return async (dispatch, getState, {getFirebase}) => {
        await dispatch({type: LOADING_SCREEN_SHOW});
        const firebase = getFirebase();
        if (getState().profile.countryId === NAM_COUNTRY_ID_NUMBER) {
            postToController(dispatch, 'ResetPasswordLink', JSON.stringify({
                Parameter: userEmail.email
            })).then(async (response) => {
                await dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>" + YOU_HAVE_MAIL + "</h3><p>" + PASSWORD_RESET_EMAIL_SENT + "</p></div>"
                    },
                });
                await dispatch({type: PASSWORD_RESET_SUCCESS});
            });
        } else {
            firebase.auth().sendPasswordResetEmail(userEmail.email)
                .then(async (resp) => {
                    await dispatch({type: LOADING_SCREEN_HIDE});
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_OK,
                            isHtml: true,
                            body: "<div class='text-center'><h3>" + YOU_HAVE_MAIL + "</h3><p>" + PASSWORD_RESET_EMAIL_SENT + "</p></div>"
                        },
                    });
                    await dispatch({type: PASSWORD_RESET_SUCCESS});
                }).catch(async (err) => {
                logErrorToDatabase("Error post password reset, Error: " + err);
                await dispatch({type: LOADING_SCREEN_HIDE});
                await dispatch({
                    type: MODAL_SHOW,
                    modalType: MODAL_TYPE_SUCCESS,
                    modalProps: {
                        header: ERROR_HEADER,
                        body: PASSWORD_RESET_EMAIL_NOT_SENT,
                    }
                });
                await dispatch({type: PASSWORD_RESET_ERROR});
            });
        }
    }
}

export const signUp = (newUser) => {
    return async (dispatch, getState, {getFirebase}) => {
        await dispatch({type: LOADING_SCREEN_SHOW});
        const firebase = getFirebase();
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then(async (resp) => {
            logEvent('SSP_User_signed_up_successfully', {});
            await dispatch({type: SIGNUP_SUCCESS, resp});
            await setFeaturesEnabled();
            await setIsLivinEnabled();
            await dispatch(navigateTo(DASHBOARD))
            await dispatch({type: LOADING_SCREEN_HIDE});
        }).catch(async (err) => {
            await dispatch({type: LOADING_SCREEN_HIDE});
            if (err.code === "auth/email-already-in-use") {
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        header: ERROR_HEADER,
                        body: EMAIL_IN_USE,
                    }
                });
            } else {
                logErrorToDatabase("Error post signUp, (" + newUser.email + ") Error: " + err);
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
            await dispatch({type: SIGNUP_ERROR});
        });
    }
}

export const signUpGuest = (email, password) => {
    return async (dispatch, getState, {getFirebase}) => {
        await dispatch({type: LOADING_SCREEN_SHOW});
        const firebase = getFirebase();
        await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        const credential = firebase.auth.EmailAuthProvider.credential(email, password);

        let policyNumber = getState().profile.guestPolicyNumber;
        if (getState().sales.email.toLowerCase().includes("@kingprice.dev")) {
            policyNumber = policyNumber.replace("KP", "KPT");
        }

        firebase.auth().currentUser.linkWithCredential(
            credential
        ).then(async (resp) => {
            logEvent('SSP_Anon_User_Upgraded_successfully', {});
            await dispatch({type: LOGIN_SUCCESS, payload: "firebase"});
            await dispatch({type: SIGNUP_SUCCESS, resp});
            var loggedInAndAuthorized = await searchCustomer(dispatch, getState, email, false);
            await requestOTPAnon(policyNumber);
        }).catch(async (err) => {
            if (err.code === "auth/provider-already-linked") {
                var loggedInAndAuthorized = await searchCustomer(dispatch, getState, email, false);
                await requestOTPAnon(policyNumber);
            } else if (err.code === "auth/email-already-in-use") {
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        header: ERROR_HEADER,
                        body: EMAIL_IN_USE,
                    }
                });
            } else {
                logErrorToDatabase("Error post signUp, (" + email + ") Error: " + err);
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        });
    }
}

export const requestOTP = (OTPToPhone) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'RequestOTP', JSON.stringify({
            Parameter: OTPToPhone
        })).then(async (response) => {
            if (response.success === true) {
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_VERIFY_OTP,
                        isHtml: true,
                    }
                });
            } else {
                logErrorToDatabase("RequestOTP failed for customer: " + getState().profile.customerId + ", OTPToPhone: " + OTPToPhone);
                await dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    otpSent: response.success,
                    otpToPhone: OTPToPhone,
                }
            });
        }).catch((err) => {
            logErrorToDatabase("Error requestOTP, Error: " + err);
        });
    }
}

export const requestOTPAnon = async (OTPToPhone) => {
    const dispatch = store.dispatch;
    await postToController(dispatch, 'RequestOTP', JSON.stringify({
        Parameter: OTPToPhone
    })).then(async (response) => {
        if (response.success === true) {
            await dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_VERIFY_OTP,
                    isHtml: true,
                }
            });
        } else {
            logErrorToDatabase("RequestOTP failed for anon customer, OTPToPhone: " + OTPToPhone);
            await dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                otpSent: response.success,
                otpToPhone: OTPToPhone,
            }
        });
    }).catch((err) => {
        logErrorToDatabase("Error requestOTP, Error: " + err);
    }).finally(async () => {
        await dispatch({type: LOADING_SCREEN_HIDE});
    });
}

export const verifyOTP = (OTP) => {
    return async (dispatch, getState) => {
        await dispatch({type: OTP_RESPONSE_WAITING});
        await dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_VERIFY_OTP,
            }
        });
        await dispatch({type: LOADING_SCREEN_SHOW});
        try {
            await postToController(dispatch, 'VerifyOTP', JSON.stringify({
                OTP: OTP,
                CustomerId: getState().profile.customerId == "" ? EMPTY_GUID : getState().profile.customerId,
                Email: getState().profile.loginEmail,
                UserId: getState().firebase.auth.uid,
                Name: getState().profile.name,
                LastName: getState().profile.surname,
                Provider: getState().auth.provider,
                SearchField: getState().auth.linkMethod
            })).then(async (response) => {
                if (response.success === true) {
                    await dispatch(navigateTo(DASHBOARD));
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_OK,
                            isHtml: true,
                            body: "<div class='text-center'><h3>Success</h3><p>" + LINKED_POLICY_SUCCESS + "</p></div>"
                        }
                    });

                    try {
                        await postSignInSignUp(dispatch, getState, getState().profile.loginEmail)
                        logInfoToDatabase("Customer policy with id: '" + getState().profile.customerId + "' linked to firebase uid: '" +
                            getState().firebase.auth.uid + "' (Email: " + getState().profile.email + ")");
                        var authorized = await doesCustomerHaveAccessToThisPolicy(dispatch, getState().profile.customerId);
                        if (authorized === 1) {
                            await processLoadCustomerDataRequest(dispatch, getState, false);
                        } else if (authorized === 0) {
                            logWarningToDatabase("Unauthorized access to customer policy with id: '" + getState().profile.customerId + "' from firebase uid: '" +
                                getState().firebase.auth.uid + "' (Email: " + getState().profile.email + ")");
                            await dispatch({
                                type: MODAL_SHOW,
                                modalProps: {
                                    type: MODAL_TYPE_ERROR,
                                    header: ERROR_HEADER,
                                    body: ERROR_OTP_REQUEST_FAILED,
                                }
                            });
                        }
                    } catch (err) {
                        logErrorToDatabase("Error post verifyOTP (check if customer has access), Error: " + err);
                    } finally {
                        await dispatch({type: LOADING_SCREEN_HIDE});
                    }
                } else {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_INVALID_OTP,
                        }
                    });
                }
            }).catch((err) => {
                logErrorToDatabase("Error verifyOTP, Error: " + err);
            })
        } finally {
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

export const verifyOTPLife = (OTP) => {
    return async (dispatch, getState) => {
        await dispatch({type: OTP_RESPONSE_WAITING});
        await dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_VERIFY_OTP,
            }
        });
        await dispatch({type: LOADING_SCREEN_SHOW});
        try {
            await postToController(dispatch, '/livin/VerifyOTP', JSON.stringify({
                OTP: OTP,
                ContactId: getState().profile.lifeContactId,
                CustomerId: getState().profile.lifeContactId,
                Email: getState().profile.email,
                UserId: getState().firebase.auth.uid,
                Name: getState().profile.name,
                LastName: getState().profile.surname,
                Provider: getState().auth.provider,
                Birthday: '',
                SearchField: getState().profile.lifeContactId,
            })).then(async (response) => {
                if (response.success === true) {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_OK,
                            isHtml: true,
                            body: "<div class='text-center'><h3>Success</h3><p>" + LINKED_POLICY_SUCCESS + "</p></div>"
                        }
                    });
                    try {
                        logInfoToDatabase("Customer policy with id: '" + getState().profile.customerId + "' linked to firebase uid: '" +
                            getState().firebase.auth.uid + "' (Email: " + getState().profile.email + ")");
                        var authorized = await doesCustomerHaveAccessToThisLifePolicy(dispatch, getState().profile.lifeContactId);
                        if (authorized === 1) {
                            await loadLifeCustomerData(dispatch, getState, false, 1000);
                        } else if (authorized === 0) {
                            logWarningToDatabase("Unauthorized access to customer policy with id: '" + getState().profile.customerId + "' from firebase uid: '" +
                                getState().firebase.auth.uid + "' (Email: " + getState().profile.email + ")");
                            await dispatch({
                                type: MODAL_SHOW,
                                modalProps: {
                                    type: MODAL_TYPE_ERROR,
                                    header: ERROR_HEADER,
                                    body: ERROR_OTP_REQUEST_FAILED,
                                }
                            });
                        }
                    } catch (err) {
                        logErrorToDatabase("Error post verifyOTP (check if customer has access), Error: " + err);
                    } finally {
                        await dispatch({type: LOADING_SCREEN_HIDE});
                    }
                } else {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_INVALID_OTP,
                        }
                    });
                }
            }).catch((err) => {
                logErrorToDatabase("Error verifyOTP, Error: " + err);
            })
        } finally {
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

async function postSignInSignUp(dispatch, getState, email) {
    dispatch({type: LOADING_SCREEN_SHOW});
    await setIsLivinEnabled();
    await setFeaturesEnabled();
    var customerDataLoadedSuccessfully = false;
    try {
        var loggedInAndAuthorized = await searchCustomer(dispatch, getState, email);
        if (getState().ssp.livinEnabled) {
            await loadLifeCustomerData(dispatch, getState, true, 1000);
        }
        if (loggedInAndAuthorized) {
            try {
                await processLoadCustomerDataRequest(dispatch, getState, false);
            } catch (err) {
                logErrorToDatabase("Error Loading policy details, Error: " + err);
            }
            await postToController(dispatch, 'LogLogin',
                JSON.stringify({
                    Fullname: getState().profile.name + " " + getState().profile.surname,
                    Username: getState().firebase.auth.email,
                    CustomerId: getState().profile.customerId,
                }))
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    showMobileProfile: true,
                }
            });
        }

        if (getState().profile.countryId === 157) {
            await dispatch({
                type: SET_I18N_DATA, payload: {
                    lat: NAM_LAT,
                    long: NAM_LONG,
                    address1: NAM_ADDRESS1,
                    address2: NAM_ADDRESS2,
                    address3: NAM_ADDRESS3,
                    address4: NAM_ADDRESS4,
                    contactUs_tel: NAM_TEL,
                    clientcare_email: NAM_CLIENT_CARE_EMAIL,
                    claims_email: NAM_CLAIMS_EMAIL,
                    sales_email: NAM_SALES_EMAIL,
                    fsp_license: NAM_KP_FSP,
                }
            });
        } else {
            await dispatch({
                type: SET_I18N_DATA, payload: {
                    lat: SA_LAT,
                    long: SA_LONG,
                    address1: SA_ADDRESS1,
                    address2: SA_ADDRESS2,
                    address3: SA_ADDRESS3,
                    address4: SA_ADDRESS4,
                    contactUs_tel: SA_TEL,
                    clientcare_email: SA_CLIENT_CARE_EMAIL,
                    claims_email: SA_CLAIMS_EMAIL,
                    sales_email: SA_SALES_EMAIL,
                    fsp_license: SA_KP_FSP,
                }
            });
        }
        //TODO Redirect manipulation dont have to be logged in
        if (getState().external.redirectType == "sale" && getState().external.redirectIdentifier != null) {
            if (getState().external.redirectIdentifier == "building") {
                let nextPage = BUILDING_AND_CONTENT_JOURNEY_BUILDER;
                if (getState().profile.policyId === "" && getState().sales.quoteId === "") {
                    await dispatch(initiateBuildingSteps());
                    await dispatch(navigateTo(nextPage));
                } else {
                    let hasAddress = (await dispatch(loadAllAddresses()))?.length > 0;
                    if (getState().profile.policyId !== "" && getState().sales.quoteId === "") {
                        await dispatch(createQuoteFromPolicy());
                        await dispatch(refreshCart());
                    }
                    await dispatch(initiateBuildingSteps());
                    await dispatch(setStep(3, hasAddress ? 1 : 2));
                    await dispatch(navigateTo(nextPage));
                }
            } else if (getState().external.redirectIdentifier == "content") {
                let nextPage = BUILDING_AND_CONTENT_JOURNEY_BUILDER;
                if (getState().profile.policyId === "" && getState().sales.quoteId === "") {
                    await dispatch(initiateHomeContentSteps());
                    await dispatch(navigateTo(nextPage));
                } else {
                    let hasAddress = (await dispatch(loadAllAddresses()))?.length > 0;
                    if (getState().profile.policyId !== "" && getState().sales.quoteId === "") {
                        await dispatch(createQuoteFromPolicy());
                        await dispatch(refreshCart());
                    }
                    await dispatch(initiateHomeContentSteps());
                    await dispatch(setStep(3, hasAddress ? 1 : 2));
                    await dispatch(navigateTo(nextPage));
                }
            } else if (getState().external.redirectIdentifier == "portable") {
                let nextPage = PERSONAL_INFO;
                if (getState().profile.policyId !== "") {
                    nextPage = PORTABLE_POSSESSIONS;
                    await dispatch(setQuoteType(PRODUCT_PORTABLE_POSSESSIONS));
                    await dispatch(newMobileClientCheck("", true, null));
                }
                dispatch(navigateTo(nextPage));
            } else if (getState().external.redirectIdentifier == "warranty") {
                var nextPage = WARRANTY_JOURNEY_BUILDER;
                if (getState().profile.policyId === "" && getState().sales.quoteId === "") {
                    await dispatch(initiateWarrantySteps());
                    await dispatch(navigateTo(nextPage));
                } else if (getState().profile.policyId !== "" && getState().sales.quoteId === "") {
                    await dispatch(createQuoteFromPolicy());
                    await dispatch(refreshCart());
                    await dispatch(initiateWarrantySteps());
                    await dispatch(setStep(3, 1));
                    await dispatch(navigateTo(nextPage));
                } else {
                    await dispatch(initiateWarrantySteps());
                    await dispatch(setStep(3, 1));
                    await dispatch(navigateTo(nextPage));
                }
            } else if (getState().external.redirectIdentifier == "codered") {
                let nextPage = CODE_RED_VIEW_BUILDER;
                if (getState().profile.policyId === "" && getState().sales.quoteId === "") {
                    await dispatch(initiateCodeRedSteps());
                    await dispatch(navigateTo(nextPage));
                } else if (getState().profile.policyId !== "" && getState().sales.quoteId === "") {
                    await dispatch(createQuoteFromPolicy());
                    await dispatch(refreshCart());
                    await dispatch(initiateCodeRedSteps());
                    await dispatch(navigateTo(nextPage));
                    await dispatch(setStep(3, 1));
                } else {
                    await dispatch(initiateCodeRedSteps());
                    await dispatch(navigateTo(nextPage));
                    await dispatch(setStep(3, 1));
                }
            }
        }
        if (getState().external.redirectType == "salelogin") {
            await dispatch(navigateTo(DASHBOARD));
            await dispatch(showAddNewItem());
        }

        if (getState().external.redirectType == "claim" && getState().external.redirectIdentifier != null) {
            if (getState().external.redirectIdentifier == "history") {
                await dispatch(navigateTo(CLAIM_HISTORY_V2));
            } else {
                var policies = getState().profile.selectedPersonalPolicy;
                let selectedCover: any = null;
                if (policies !== undefined) {
                    for (var i = 0; i < policies.covers.length; i++) {
                        var cover = policies.covers[i];
                        if (cover.isMainline === true && cover.id === getState().external.redirectIdentifier) {
                            selectedCover = cover;
                            break;
                        }

                        if (getState().external.redirectIdentifier !== EMPTY_GUID) {
                            for (var j = 0; j < cover.riskItems.length; j++) {
                                var riskItem = cover.riskItems[j];
                                if (riskItem.riskItemId == getState().external.redirectIdentifier) {
                                    selectedCover = cover;
                                    break;
                                }
                            }
                            ;
                        }
                    }
                    ;
                    if (selectedCover === null) {
                        selectedCover = getState().profile.personalPolicies[0].covers.filter(function (item) {
                            return item.productName == "Portable possessions";
                        })
                        await dispatch(setSelectedCover(selectedCover[0].id));

                        selectedCover = selectedCover[0].riskItems[0].portablePossessions.filter(function (item) {
                            return item.id == getState().external.redirectIdentifier;
                        })
                        selectedCover = {
                            id: selectedCover[0].id,
                            productName: "Portable possessions",
                            riskItems: [selectedCover[0]]
                        }
                    }
                    await dispatch(resetFNOL());
                    await dispatch(clearSelectedDamages());
                    await dispatch(setCoverFromPersonalInsurance(selectedCover));
                    await dispatch(setStepClaim(1, 1));
                    await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
                }
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
        }
        if (getState().external.redirectType == "cover" && getState().external.redirectIdentifier != null) {
            if (getState().external.redirectIdentifier == "portable") {
                let selectedCover: any = null;
                let policies = getState().profile.personalPolicies;
                if (policies) {
                    policies.forEach(policy => {
                        for (var i = 0; i < policy.covers.length; i++) {
                            var cover = policy.covers[i];
                            if (cover.productName === "Portable possessions") {
                                selectedCover = cover;
                                break;
                            }
                        }
                    });
                }
                await dispatch(setSelectedCover(selectedCover.id));
                await dispatch(navigateTo(POLICY_DETAILS));
            } else {
                await dispatch(setSelectedCover(getState().external.redirectIdentifier));
                await dispatch(navigateTo(POLICY_DETAILS));
            }
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    showMobileProfile: false,
                }
            });
        }
        if (getState().external.redirectType == "selfinspect" && getState().external.redirectIdentifier !== null) {
            let selectedCover: any = null;
            let selectedFutureCover: any = null;
            let policies = getState().profile.personalPolicies;
            if (policies) {
                policies.forEach(policy => {
                    for (var i = 0; i < policy.covers.length; i++) {
                        var cover = policy.covers[i];
                        if (cover.isMainline === true && (cover.riskItems.filter(x => x.riskItemId === getState().external.redirectIdentifier).length > 0)) {
                            selectedCover = cover;
                            break;
                        }
                    }
                });
            }

            if (selectedCover !== null) {
                await dispatch(setSelectedCover(selectedCover.id));
                await dispatch(syncCoverWithProfile());
            } else {
                let futureCovers = getState().profile.quotedFutureItems;
                if (futureCovers) {
                    for (var i = 0; i < futureCovers.length; i++) {
                        var cover = futureCovers[i];
                        if (cover.quoteRiskItem.quoteRiskItemLinkingId === getState().external.redirectIdentifier) {
                            selectedFutureCover = cover;
                            break;
                        }
                    }
                }

                if (selectedFutureCover !== null) {
                    await dispatch(setSelectedQuotedCover(selectedFutureCover.id));
                    await dispatch(syncCoverWithProfile());
                }
            }

            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    showMobileProfile: false,
                }
            });
        }

        await dispatch({
            type: SET_EXTERNAL_DATA,
            payload: {riskItemId: null, type: null, redirectIdentifier: null}
        });
        customerDataLoadedSuccessfully = true;
    } catch(err) {
        logErrorToDatabase("Error in postSignInSignUp, Error: " + err);
    }
    return customerDataLoadedSuccessfully;
}

export async function postPolicyCreation(dispatch, getState, email) {
    var customerDataLoadedSuccessfully = false;
    try {
        var loggedInAndAuthorized = await searchCustomer(dispatch, getState, email);
        if (loggedInAndAuthorized) {
            try {
                await getCustomerInfo(dispatch, getState().profile.customerId);
                await getPolicyDetails(dispatch, getState().profile.customerId);
                await dispatch(getUserBankingDetails());
            } catch (err) {
                logErrorToDatabase("Error retrieving bank details, Error: " + err);
            }
            await dispatch({
                type: RESET_QUOTE_DATA, payload: {}
            });
            await dispatch({
                type: RESET_CART_DATA, payload: {}
            });
            await dispatch(navigateTo(PERSONAL_INSURANCE));
        }

        customerDataLoadedSuccessfully = true;
    } catch (err) {
        logErrorToDatabase("Error in postSignInSignUp, Error: " + err);
    }
    return customerDataLoadedSuccessfully;
}

export async function postPolicyUpdate(dispatch, getState, email) {
    await dispatch({type: POLICY_LOAD_VIEW_SCREEN_SHOW});
    try {
        try {
            await getCustomerInfo(dispatch, getState().profile.customerId);
            await getPolicyDetails(dispatch, getState().profile.customerId);
            await dispatch(getUserBankingDetails());
        } catch (err) {
            logErrorToDatabase("Error retrieving bank details, Error: " + err);
        }
        await dispatch({
            type: RESET_QUOTE_DATA, payload: {}
        });
        await dispatch({
            type: RESET_CART_DATA, payload: {}
        });
        await dispatch(navigateTo(PERSONAL_INSURANCE));
    } catch (err) {
        logErrorToDatabase("Error in postSignInSignUp, Error: " + err);
    }
    await dispatch({type: POLICY_LOAD_VIEW_SCREEN_HIDE});
    return true;
}

export async function refreshPolicyData(dispatch, getState, email) {
    try {
        try {
            await getPolicyDetails(dispatch, getState().profile.customerId);
        } catch (err) {
            logErrorToDatabase("Error retrieving bank details, Error: " + err);
        }
    } catch (err) {
        logErrorToDatabase("Error in postSignInSignUp, Error: " + err);
    }
    return true;
}

async function searchCustomer(dispatch, getState, parameter, checkLink: boolean = true): Promise<boolean> {
    var functionResponse = false;
    try {
        await postToController(dispatch, 'SearchCustomer',
            JSON.stringify({Email: parameter, Provider: getState().auth.provider})).then(async (response) => {
            if (response !== "Failure") {
                if (response.isCustomer) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            customerId: response.id,
                            cellphoneNumber: response.cellPhone,
                            email: response.email,
                        }
                    });
                    if (checkLink) {
                        functionResponse = await checkCustomerLink(dispatch, getState, parameter);
                    }
                }
            } else throw new Error("Failure in controller to backend");
        })
    } catch (err) {
        logErrorToDatabase("Error in searchCustomer: " + err);
        throw err;
    }
    return functionResponse;
}

async function searchLifeCustomer(dispatch, getState, policyNumber): Promise<boolean> {
    var functionResponse = false;
    try {
        await postToController(dispatch, '/livin/SearchCustomer', JSON.stringify({PolicyNumber: policyNumber})).then(async (response) => {
            if (response !== "Failure") {
                if (response.isCustomer === true) {
                    dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            lifeContactId: response.id,
                            cellphoneNumber: response.cellPhone,
                            email: response.email
                        }
                    })
                }
                functionResponse = await checkLifeCustomerLinkWithOtp(dispatch, getState, response.isCustomer);
            } else throw new Error("Failure in controller to backend");
        });
    } catch (err) {
        logErrorToDatabase("Error in searchLifeCustomer: " + err);
        throw err;
    }
    return functionResponse;
}

async function searchCustomerOtp(dispatch, getState, parameter): Promise<boolean> {
    var functionResponse = false;
    try {
        await postToController(dispatch, 'SearchCustomer',
            JSON.stringify({Email: parameter})).then(async (response) => {
            if (response !== "Failure") {
                if (response.isCustomer === true) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            customerId: response.id,
                            cellphoneNumber: response.cellPhone,
                            email: response.email,
                        }
                    });
                }
                functionResponse = await checkCustomerLinkWithOtp(dispatch, getState, parameter);
            } else throw new Error("Failure in controller to backend");
        })
    } catch (err) {
        logErrorToDatabase("Error in searchCustomerOtp: " + err);
        throw err;
    }
    return functionResponse;
}

async function checkCustomerLinkWithOtp(dispatch, getState, isCustomer): Promise<boolean> {
    var functionResponse = false;
    try {
        dispatch({type: LOADING_SCREEN_SHOW});

        var userId = getState().firebase.auth.uid;
        await postToController(dispatch, 'IsCustomerLinked',
            JSON.stringify({Parameter: userId})).then(async (response) => {

            var isLinked = response.userId !== null;
            if (!isLinked) { // customer is not linked
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        isLinked: false,
                    }
                });
            } else { // customer is linked
                var customerId = getState().profile.customerId;
                try {
                    if (response.entityTypeLink !== null && response.entityTypeLink !== undefined && response.entityTypeLink[0] !== undefined) {
                        customerId = response.entityTypeLink[0].id
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                customerId: customerId
                            }
                        });
                    }
                } catch (err) {
                    logErrorToDatabase("Exception checking entityTypeLink, Error: " + err);
                }
                var authorized = await doesCustomerHaveAccessToThisPolicy(dispatch, customerId);
                if (authorized === 1) {
                    functionResponse = true;
                    await loadCustomerData(dispatch, getState, true, 1000);
                } else if (authorized === 0) {
                    logWarningToDatabase("Unauthorized access to customer policy with id: '" + customerId + "' from firebase uid: '" + userId + "' (Email: " + getState().profile.email + ")");
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                } /*else if (authorized === -1) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                    logErrorToDatabase("doesCustomerHaveAccessToThisPolicy returned -1");
                }*/
            }
        })
    } catch (err) {
        logErrorToDatabase("Error in checkCustomerLink, Error: " + err);
        throw err;
    }
    return functionResponse;
}

async function checkCustomerLink(dispatch, getState, isCustomer): Promise<boolean> {
    var functionResponse = false;
    try {
        if (!isCustomer) {
            //dispatch({ type: REDIRECT, payload: USER_ONBOARDING });
        }
        dispatch({type: LOADING_SCREEN_SHOW});

        var userId = getState().firebase.auth.uid;
        await postToController(dispatch, 'IsCustomerLinked',
            JSON.stringify({Parameter: userId})).then(async (response) => {
            var isLinked = response.userId !== null;
            if (!isLinked) { // customer is not linked
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        isLinked: false,
                    }
                });
            } else { // customer is linked
                var customerId = getState().profile.customerId;
                try {
                    if (response.entityTypeLink !== null && response.entityTypeLink !== undefined && response.entityTypeLink[0] !== undefined) {
                        customerId = response.entityTypeLink[0].id
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                customerId: customerId
                            }
                        });
                    }
                } catch (err) {
                    logErrorToDatabase("Exception checking entityTypeLink, Error: " + err);
                }
                var authorized = await doesCustomerHaveAccessToThisPolicy(dispatch, customerId);
                if (authorized === 1) {
                    functionResponse = true;
                    await loadCustomerData(dispatch, getState, true, 1000);
                } else if (authorized === 0) {
                    logWarningToDatabase("Unauthorized access to customer policy with id: '" + customerId + "' from firebase uid: '" + userId + "' (Email: " + getState().profile.email + ")");
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                } else if (authorized === -1) {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                    logErrorToDatabase("doesCustomerHaveAccessToThisPolicy returned -1");
                }
            }
        })
    } catch (err) {
        logErrorToDatabase("Error in checkCustomerLink, Error: " + err);
        throw err;
    }
    return functionResponse;
}

async function checkLifeCustomerLinkWithOtp(dispatch, getState, isCustomer): Promise<boolean> {
    var functionResponse = false;
    try {
        var userId = getState().firebase.auth.uid;
        await postToController(dispatch, '/livin/IsCustomerLinked',
            JSON.stringify({Parameter: userId})).then(async (response) => {
            var isLinked = response.userId !== null;
            if (!isLinked) { // customer is not linked
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        isLifeLinked: false,
                    }
                });
                await dispatch({
                    type: SET_LINK_METHOD,
                    payload: {
                        linkMethod: isCustomer,
                    }
                });
                await postToController(dispatch, '/livin/RequestOTP', JSON.stringify({
                    OTPToPhone: false,
                    CustomerId: getState().profile.lifeContactId
                })).then(async (response) => {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_VERIFY_OTP_LIFE,
                            isHtml: true,
                        }

                    });
                });
            } else { // customer is linked
                var contactId = getState().profile.lifeContactId;
                try {
                    if (response.entityTypeLink !== null && response.entityTypeLink !== undefined && response.entityTypeLink[0] !== undefined) {
                        contactId = response.entityTypeLink[0].id
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                lifeContactId: contactId
                            }
                        });
                    }
                } catch (err) {
                    logErrorToDatabase("Exception checking entityTypeLink, Error: " + err);
                }
                var authorized = await doesCustomerHaveAccessToThisLifePolicy(dispatch, contactId);
                if (authorized === 1) {
                    functionResponse = true;
                    await loadLifeCustomerData(dispatch, getState, false, 1000);
                } else if (authorized === 0) {
                    logWarningToDatabase("Unauthorized access to customer policy with id: '" + contactId + "' from firebase uid: '" + userId + "' (Email: " + getState().profile.email + ")");
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                } else if (authorized === -1) {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_OTP_REQUEST_FAILED,
                        }
                    });
                    logErrorToDatabase("doesCustomerHaveAccessToThisPolicy returned -1");
                }
            }
        })
    } catch (err) {
        logErrorToDatabase("Error in checkCustomerLink, Error: " + err);
        throw err;
    }
    return functionResponse;
}

export async function loadCustomerData(dispatch, getState, loadPolicyData: boolean, delay: number) {
    var firebaseIsLoaded = isLoaded(getState().firebase.auth.lastLoginAt) && !isEmpty(getState().firebase.auth.lastLoginAt);
    if (firebaseIsLoaded) {
        var LogInLastHour = new Date();
        LogInLastHour.setHours(LogInLastHour.getHours() - 1);
        if ((getState().firebase.auth.lastLoginAt < LogInLastHour.getTime().toString())) {
            await processLoadCustomerDataRequest(dispatch, getState, loadPolicyData);
        }
    } else {
        setTimeout(async () => {
            var firebaseIsLoaded = isLoaded(getState().firebase.auth.lastLoginAt) && !isEmpty(getState().firebase.auth.lastLoginAt);
            if (firebaseIsLoaded) {
                var LogInLastHour = new Date();
                LogInLastHour.setHours(LogInLastHour.getHours() - 1);
                if ((getState().firebase.auth.lastLoginAt < LogInLastHour.getTime().toString())) {
                    await processLoadCustomerDataRequest(dispatch, getState, loadPolicyData);
                }
            }
        }, delay);
    }
}

export async function loadLifeCustomerData(dispatch, getState, loadPolicyData: boolean, delay: number) {
    if (getState().ssp.livinEnabled) {
        await getLifeCustomerInfo(dispatch, null);
        var firebaseIsLoaded = isLoaded(getState().firebase.auth.lastLoginAt) && !isEmpty(getState().firebase.auth.lastLoginAt);
        if (firebaseIsLoaded) {
            var LogInLastHour = new Date();
            LogInLastHour.setHours(LogInLastHour.getHours() - 1);
            if ((getState().firebase.auth.lastLoginAt < LogInLastHour.getTime().toString()) || !getState().lifePolicy.policy?.id || !getState().lifePolicy.contact?.id) {
                await processLoadLifeCustomerDataRequest(dispatch, getState, loadPolicyData);
            }
        } else {
            setTimeout(async () => {
                var firebaseIsLoaded = isLoaded(getState().firebase.auth.lastLoginAt) && !isEmpty(getState().firebase.auth.lastLoginAt);
                if (firebaseIsLoaded) {
                    var LogInLastHour = new Date();
                    LogInLastHour.setHours(LogInLastHour.getHours() - 1);
                    if ((getState().firebase.auth.lastLoginAt < LogInLastHour.getTime().toString()) || !getState().lifePolicy.policy?.id || !getState().lifePolicy.contact?.id) {
                        await processLoadLifeCustomerDataRequest(dispatch, getState, loadPolicyData);
                    }
                }
            }, delay);
        }
    }
}

async function processLoadCustomerDataRequest(dispatch, getState, loadPolicyData: boolean) {
    dispatch({type: LOADING_SCREEN_SHOW});
    var isLinked = getState().profile.isLinked;
    if (isLinked) {
        var customerId = getState().profile.customerId;

        if (loadPolicyData) {
            await getPolicyDetails(dispatch, customerId);
        }
        await getCustomerInfo(dispatch, customerId);
        await checkDonateMyDecrease(dispatch, getState);
        await dispatch(getCustomerClaims());
        await dispatch(getUserBankingDetails());
        await dispatch(checkSpecialDebitDate());
        if (isMobile) {
            await dispatch(checkContinueAndSetData());
            let riskItemId = getState().external.riskItemId;
            if (riskItemId !== null || getState().external.riskItemId !== "") {
                let selectedCover: any = null;
                let selectedFutureCover: any = null;
                let policies = getState().profile.personalPolicies;
                if (policies) {
                    policies.forEach(policy => {
                        for (var i = 0; i < policy.covers.length; i++) {
                            var cover = policy.covers[i];
                            if (cover.isMainline === true && (cover.riskItems.filter(x => x.riskItemId === riskItemId).length > 0)) {
                                selectedCover = cover;
                                break;
                            }
                        }
                        ;
                    });
                }

                if (selectedCover !== null) {
                    await dispatch(setSelectedCover(selectedCover.id));
                    await dispatch(syncCoverWithProfile());
                } else {
                    let futureCovers = getState().profile.quotedFutureItems;
                    if (futureCovers) {
                        for (var i = 0; i < futureCovers.length; i++) {
                            var cover = futureCovers[i];
                            if (cover.quoteRiskItem.quoteRiskItemLinkingId === riskItemId) {
                                selectedFutureCover = cover;
                                break;
                            }
                        }
                    }

                    if (selectedFutureCover !== null) {
                        await dispatch(setSelectedQuotedCover(selectedFutureCover.id));
                        await dispatch(syncCoverWithProfile());
                    }
                }

                await dispatch({type: SET_EXTERNAL_DATA, payload: {riskItemId: null}});
            }
        }

        let email = getState().profile.email;

        if (email === undefined || email.toString().trim().length == 0) {
            await dispatch(showModalNoEmail());
        } else if (!validateEmail.test(email) || email.startsWith("nomail@")) {
            await dispatch(showModalInvalidEmail());
        }

        await dispatch({type: LOADING_SCREEN_HIDE});
    }
}

async function processLoadLifeCustomerDataRequest(dispatch, getState, loadPolicyData: boolean) {
    dispatch(showLoadingScreen());
    try {
        let isLinked = getState().profile.isLifeLinked;
        if (isLinked) {
            let contactId = getState().profile.lifeContactId;
            if (loadPolicyData) {
                await getLifePolicyDetails(dispatch);
            }
            await getLifeCustomerInfo(dispatch, contactId);
        }
    } catch (e) {
        throw e;
    } finally {
        await dispatch(hideLoadingScreen());
    }
}

export const linkCustomer = (parameter) => {
    return async (dispatch, getState) => {
        try {
            await dispatch({type: LOADING_SCREEN_SHOW});
            await requestOTP(parameter);
        } finally {
            await dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

export const linkLifeCustomer = (parameter) => {
    return async (dispatch, getState) => {
        try {
            dispatch({type: LOADING_SCREEN_SHOW});
            await searchLifeCustomer(dispatch, getState, parameter);
        } finally {
            dispatch({type: LOADING_SCREEN_HIDE});
        }
    }
}

async function getCustomerInfo(dispatch, customerId) {
    await postToController(dispatch, 'GetPersonDetailsByCustomerId',
        JSON.stringify({Parameter: customerId})).then(async (response) => {
        try {
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    email: response.email,
                    cellphoneNumber: response.cellPhone,
                    alternateNumber: response.alternateContactNumber,
                    preferredLanguage: response.language,
                    title: response.title,
                    homePhone: response.homePhone,
                    idNumber: response.idNumber,
                    name: response.firstName,
                    surname: response.surname,
                    gender: response.gender
                }
            });
        } catch (err) {
            logErrorToDatabase("Error in getCustomerInfo, Error: " + err);
        }
    })
}

async function getLifeCustomerInfo(dispatch, customerId) {
    await postToController(dispatch, 'livin/GetContactInfo',
        JSON.stringify(null)).then(async (response) => {
        try {
            await dispatch({
                type: SET_LIFE_CONTACT, payload: {
                    email: response.email,
                    phoneMobile: response.phoneMobile,
                    phoneHome: response.phoneHome,
                    phoneWork: response.phoneWork,
                    salutation: response.salutation,
                    idNumber: response.idNumber,
                    name: response.name,
                    knownAs: response.knownAs,
                    lastName: response.lastName,
                    firstName: response.firstName,
                    gender: response.gender,
                    claimant: response.claimant,
                }
            });
            if (response.id) {
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        isLifeLinked: true,
                    }
                });
            }

        } catch (err) {
            logErrorToDatabase("Error in getLifeCustomerInfo, Error: " + err);
        }
    })
}

export const getCustomerClaims = () => {
    return async (dispatch, getState) => {
        var result = false;

        await postToController(dispatch, 'GetCustomerClaims',
            JSON.stringify({CustomerId: getState().profile.customerId, PolicyId: getState().profile.policyId}))
            .then(async (response) => {
                try {
                    if (response !== null && response !== "Failure" && response !== "" && JSON.stringify(response) !== '{}' && response[0] !== null && response[0] !== undefined) {
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                personalClaims: response,
                                selectedPersonalClaim: response[0],
                            }
                        });
                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                selectedClaim: response[0],
                            }
                        });
                        await dispatch(getClaimProgress(response[0].claimID));
                        await dispatch(getNextProgressStepName());
                        await dispatch(setLoadingAndEmpty(false, false));
                        result = true;
                    } else {
                        await dispatch(setLoadingAndEmpty(false, true));
                    }
                } catch (err) {
                    logErrorToDatabase("Error in getCustomerClaims, Error: " + err);
                }
            });

        return result;
    };
}

/**
 * return -1 for errors
 * return 0 for false (not allowed)
 * return 1 for true (allowed)
 * @param dispatch
 * @param customerId
 */
async function getPolicyDetails(dispatch, customerId): Promise<number> {
    var result = 0;
    await postToController(dispatch, 'GetPolicyDataByCustomerId',
        JSON.stringify({Parameter: customerId})).then(async (response) => {
        try {
            if (response !== "Failure" && response !== "") {
                var policyDetails = response[0];
                let firstCover = null;
                if (policyDetails !== undefined) {
                    for (var i = 0; i < policyDetails.covers.length; i++) {
                        var cover = policyDetails.covers[i];
                        if (cover.isMainline === true) {
                            firstCover = cover;
                            break;
                        }
                    }
                    ;

                    let currencySymbol = (policyDetails.countryId === 244) ? 'R' : 'N$';
                    let googleMapsCountryCode = (policyDetails.countryId === 244) ? 'za' : 'na';
                    if (policyDetails.countryId === 157) {
                        await dispatch({
                            type: SET_I18N_DATA, payload: {
                                lat: NAM_LAT,
                                long: NAM_LONG,
                                address1: NAM_ADDRESS1,
                                address2: NAM_ADDRESS2,
                                address3: NAM_ADDRESS3,
                                address4: NAM_ADDRESS4,
                                contactUs_tel: NAM_TEL,
                                clientcare_email: NAM_CLIENT_CARE_EMAIL,
                                claims_email: NAM_CLAIMS_EMAIL,
                                sales_email: NAM_SALES_EMAIL,
                                fsp_license: NAM_KP_FSP,
                            }
                        });
                    } else {
                        await dispatch({
                            type: SET_I18N_DATA, payload: {
                                lat: SA_LAT,
                                long: SA_LONG,
                                address1: SA_ADDRESS1,
                                address2: SA_ADDRESS2,
                                address3: SA_ADDRESS3,
                                address4: SA_ADDRESS4,
                                contactUs_tel: SA_TEL,
                                clientcare_email: SA_CLIENT_CARE_EMAIL,
                                claims_email: SA_CLAIMS_EMAIL,
                                sales_email: SA_SALES_EMAIL,
                                fsp_license: SA_KP_FSP,
                            }
                        });
                    }

                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            policyId: policyDetails.id,
                            countryId: policyDetails.countryId,
                            activePolicies: response.length,
                            personalPolicies: response,
                            selectedPersonalCover: firstCover,
                            selectedPersonalPolicy: response[0],
                            currencySymbol: currencySymbol,
                            googleMapsCountryCode: googleMapsCountryCode,
                            broker: policyDetails.broker
                        }
                    });
                    result = 1;
                }
            } else if (response === "Failure") {
                result = -1;
            }
        } catch (err) {
            logErrorToDatabase("Error in getPolicyDetails: " + err);
        }
    }).catch((err) => {
        logErrorToDatabase("Error in getPolicyDetails catch: " + err);
        result = -1;
    });

    let quotedItems: any = [];
    await postToController(dispatch, 'GetQuotedFutureCoverByCustomerId',
        JSON.stringify({Parameter: customerId})).then(async (response) => {
        try {
            if (response !== "Failure" && response !== "") {
                quotedItems = response;
                await dispatch({
                    type: SET_QUOTED_FUTURE_ITEMS,
                    payload: response
                });
            } else if (response === "Failure") {
                result = -1;
            }
        } catch (err) {
            logErrorToDatabase("Error in getPolicyDetails > getQuotedFutureCoverByCustomerId catch: " + err);
            result = -1;
        }
    }).catch((err) => {
        logErrorToDatabase("Error in getPolicyDetails > getQuotedFutureCoverByCustomerId catch: " + err);
        result = -1;
    });

    if (quotedItems.length > 0) {
        let quoteIds: any = [];
        quotedItems.forEach(async (quoteItem) => {
            if (quoteIds.filter(x => x === quoteItem.quoteId).length === 0) {
                quoteIds.push(quoteItem.quoteId);

                await postToController(dispatch, 'GetInspectionItemsOnQuote',
                    JSON.stringify({Parameter: quoteItem.quoteId})).then(async (response) => {
                    try {
                        if (response !== "Failure" && response !== "") {
                            await dispatch({
                                type: SET_INSPECTION_ITEMS,
                                payload: response
                            });
                        } else if (response === "Failure") {
                            result = -1;
                        }
                    } catch (err) {
                        logErrorToDatabase("Error in getPolicyDetails > GetInspectionItemsOnQuote catch: " + err);
                        result = -1;
                    }
                }).catch((err) => {
                    logErrorToDatabase("Error in getPolicyDetails > GetInspectionItemsOnQuote catch: " + err);
                    result = -1;
                });
            }
        });
    } else {
        await dispatch({
            type: SET_INSPECTION_ITEMS,
            payload: []
        });
    }

    return result;
}

async function getLifePolicyDetails(dispatch): Promise<number> {
    let result = 0;
    await postToController(dispatch, '/livin/GetPolicyDetails',
        JSON.stringify(null)).then(async (response) => {
        try {
            if (response !== "Failure" && response !== "") {
                const policy = response;

                if (policy) {
                    let currencySymbol = 'R';

                    await dispatch({
                        type: SET_LIFE_POLICY, payload: policy
                    });

                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            activeLifePolicies: response.length,
                            lifePolicyId: policy.id,
                            currencySymbol: currencySymbol,
                        }
                    });
                    result = 1;
                }
            } else if (response === "Failure") {
                result = -1;
            }
        } catch (err) {
            logErrorToDatabase("Error in getLifePolicyDetails: " + err);
        }
    }).catch((err) => {
        logErrorToDatabase("Error in getLifePolicyDetails catch: " + err);
        result = -1;
    });
    return result;
}


/**
 * return -1 for errors
 * return 0 for false (not allowed)
 * return 1 for true (allowed)
 */
async function doesCustomerHaveAccessToThisPolicy(dispatch, customerId): Promise<number> {
    let response = 0;
    let isAllowed = await getPolicyDetails(dispatch, customerId);
    response = isAllowed;
    if (isAllowed === 1) {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                isLinked: true,
            }
        });
    }
    return response;
}

/**
 * return -1 for errors
 * return 0 for false (not allowed)
 * return 1 for true (allowed)
 */
async function doesCustomerHaveAccessToThisLifePolicy(dispatch, customerId): Promise<number> {
    let response = 0;
    let isAllowed = await getLifePolicyDetails(dispatch);
    response = isAllowed;
    if (isAllowed === 1) {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                isLifeLinked: true,
            }
        });
    }
    return response;
}

async function checkDonateMyDecrease(dispatch, getState) {
    await postToController(dispatch, 'GetLastPolicyDecreaseOption',
        JSON.stringify({Parameter: getState().profile.policyId})).then(async (response) => {
        try {
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    isDecreaseDonated: response.isActive,
                    donationOrganizationId: response.id,
                }
            });
        } catch (err) {
            logErrorToDatabase("Error in checkDonateMyDecrease, Error: " + err);
        }
    })
}

export const clearCache = () => {
    return () => {
        if (caches !== undefined && caches) {
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });

            window.localStorage.clear();
            signOut();
        }
    }
}

export const showLoadingScreenDispatch = async (dispatch) => {
    dispatch({
        type: LOADING_SCREEN_SHOW
    })
    return true;
}

export const hideLoadingScreenDispatch = async (dispatch) => {
    dispatch({
        type: LOADING_SCREEN_HIDE
    })
}

export const SignInWithOTPToken = (Otp: string, NavigateTo: string) => {
    return async (dispatch, getState, {getFirebase}) => {
        await showLoadingScreenDispatch(dispatch);
        const firebase = getFirebase();
        postToController(dispatch, 'VerifyRedirectOTP',
            JSON.stringify({Parameter: Otp})).then(async (customTokenResponse) => {
            if (customTokenResponse != null) {
                await firebase.auth().signInWithCustomToken(customTokenResponse)
                    .catch(async (err) => {
                        await hideLoadingScreenDispatch(dispatch);
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: "There was an error signing you in",
                            }
                        });
                        await dispatch({type: LOGIN_ERROR});
                        signOut();
                    }).then(async (credentials) => {
                        if (credentials) {
                            await dispatch({
                                type: SET_CUSTOMER_DATA,
                                payload: {email: credentials.email, loginEmail: credentials.email}
                            });
                            if (await postSignInSignUp(dispatch, getState, credentials.email)) {
                                await dispatch({type: LOGIN_SUCCESS, payload: "customtoken"});
                            } else {
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: MODAL_TYPE_ERROR,
                                        header: ERROR_HEADER,
                                        body: "There was an error signing you in",
                                    }
                                });
                                await dispatch({type: LOGIN_ERROR});
                                signOut();
                            }
                        } else {
                            await dispatch({type: LOGIN_ERROR});
                            signOut();
                        }
                    }).finally(async () => {
                        await dispatch(loginComplete(false, false));
                    })
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: "There was an error signing you in",
                    }
                });
                signOut();
                dispatch(navigateTo(HOME));
            }
        }).finally(async () => {
            await hideLoadingScreenDispatch(dispatch);
        })
    }
}